import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { AccountRules } from "@/constants/breadcrumb";
import Position from "./position/index";
import Evaluation from "./evaluation/index";
import { Tabs } from "antd";

import "./index.scss";
const { TabPane } = Tabs;
const tabs = [
  {
    label: "点位规则设置",
    key: "position",
    children: <Position />,
  },
  {
    label: "评价扣款规则",
    key: "evaluate",
    children: <Evaluation />,
  },
];

const Page = (props) => {
  const containerRef = useRef(null);

  useEffect(() => {}, []);

  return (
    <div className="account-page" ref={containerRef}>
      <Headers BreadCrumbData={AccountRules}></Headers>

      <div className="pt-24 pl-32 pr-32">
        <div className="tabs">
          <Tabs items={tabs}>
            {tabs.map((tab) => (
              <TabPane tab={tab.label} key={tab.key}>
                {tab.children}
              </TabPane>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
};
export default Page;
